import script from "./columnBookCards.vue?vue&type=script&setup=true&lang=js"
export * from "./columnBookCards.vue?vue&type=script&setup=true&lang=js"

import "./columnBookCards.vue?vue&type=style&index=0&id=4eda36da&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.27_vue@3.4.27_webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eda36da"]])

export default __exports__